var vars = require('./core');

module.exports = vars.createClass('Pie', ['getSegmentsAtEvent']);



//////////////////
// WEBPACK FOOTER
// ./~/react-chartjs/lib/pie.js
// module id = 1112
// module chunks = 0